<app-layout title="Revisión de Informe">
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link" 
         [class.active]="activeTab === 'tab1'"
         (click)="changeTab('tab1')">Resumen de Informe</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" 
         [class.active]="activeTab === 'tab2'"
         (click)="changeTab('tab2')">Agregar Conceptos</a>
    </li>
  </ul>
  
  <div class="tab-content mt-3">
    <div class="tab-pane fade" [class.show]="activeTab === 'tab1'" [class.active]="activeTab === 'tab1'" id="tab1">
      <app-view-concepts></app-view-concepts> 
    </div>
    <div class="tab-pane fade" [class.show]="activeTab === 'tab2'" [class.active]="activeTab === 'tab2'" id="tab2">
     <app-add-edit-concept-response></app-add-edit-concept-response> 
    </div>
  </div>
  </app-layout>